import { Lock } from "lucide-react";
import { usd, BASE_PRICE, DEPOSIT } from "@/lib/addons";
import { WINDOWS } from "@/lib/booking";

const Row = ({ k, v, muted }) => (
  <div className="flex justify-between gap-4 text-sm"><dt className={muted ? "text-sec" : "text-ink"}>{k}</dt><dd className="text-right font-mono text-ink">{v}</dd></div>
);

export const StepPayment = ({ data, price }) => (
  <div className="space-y-6" data-testid="step-payment">
    <div className="rounded-md border border-forest bg-mint p-5 sm:p-6">
      <p className="mono uppercase tracking-[0.16em] text-sec">Due today</p>
      <p className="mt-1 font-serif text-5xl leading-none text-forest" data-testid="payment-due-today">{usd(price.dueToday)}</p>
      <dl className="mt-4 space-y-1.5 border-t border-forest/10 pt-4">
        <Row k="Deposit · Home Hyper Assessment" v={usd(DEPOSIT)} />
        {price.addons.map((a) => <Row key={a.id} k={a.name} v={usd(a.price)} />)}
      </dl>
    </div>
    <p className="text-sm text-ink leading-relaxed">
      <span className="font-semibold">Remaining base balance: <span data-testid="payment-remaining">{usd(BASE_PRICE - DEPOSIT)}</span></span> <span className="text-sec">due 24 hours before your visit. Your deposit is applied toward the {usd(BASE_PRICE)} assessment.</span>
    </p>
    <dl className="rounded-md border border-divider p-4 space-y-1.5" data-testid="payment-visit">
      <Row k="Visit" v={`${data.dateLabel} · ${WINDOWS.find((w) => w.id === data.window)?.label}`} muted />
      <Row k="Address" v={`${data.address}${data.apt ? `, ${data.apt}` : ""}`} muted />
      <Row k="Email" v={data.email.trim()} muted />
    </dl>
    <p className="flex items-start gap-2 text-xs text-sec leading-relaxed"><Lock size={13} className="mt-0.5 shrink-0" /> You’ll complete payment on Stripe’s secure checkout. Apple Pay and Google Pay are offered where available.</p>
  </div>
);
